import { DialogHeader, DialogTitle } from "@/lib/components/Dialog";
import { cn } from "@/lib/utils";

function SidebarPanelWrapper({
  children,
  className,
}: {
  children: React.ReactNode;
  className?: string;
}) {
  return <div className={cn("flex h-full w-full", className)}>{children}</div>;
}

function SidebarPanelLayout({ children }: { children: React.ReactNode }) {
  return <div className="flex h-full w-full flex-col">{children}</div>;
}

function SidebarPanelHeader({
  title,
  onBackClick,
}: {
  title: string;
  onBackClick?: () => void;
  children?: React.ReactNode;
  className?: string;
}) {
  return (
    <DialogHeader
      variant="bordered"
      onBack={onBackClick}
      className="min-h-18 px-8 pr-5"
    >
      <DialogTitle>{title}</DialogTitle>
    </DialogHeader>
  );
}

function SidebarPanelBody({ children }: { children: React.ReactNode }) {
  return <div className="flex min-h-0 flex-1">{children}</div>;
}

function SidebarPanelLeftSidebar({
  children,
  className,
}: {
  children?: React.ReactNode;
  className?: string;
}) {
  return (
    <aside
      className={cn(
        "flex w-71.25 flex-col border-r border-grey-200",
        className,
      )}
    >
      {children}
    </aside>
  );
}

function SidebarPanelContent({
  children,
  className,
}: {
  children?: React.ReactNode;
  className?: string;
}) {
  return (
    <div className={cn("relative flex min-h-0 flex-1 flex-col", className)}>
      {children}
    </div>
  );
}

export {
  SidebarPanelWrapper,
  SidebarPanelLayout,
  SidebarPanelHeader,
  SidebarPanelBody,
  SidebarPanelLeftSidebar,
  SidebarPanelContent,
};
